import { useEffect, createContext } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Modal,
  Space,
  Spin,
  Card,
  Row,
  Col,
  Flex,
  Dropdown,
  MenuProps,
} from "antd";

import { DownOutlined } from "@ant-design/icons";

import ObjectForm from "components/Admin/ObjectForm";

import { RootState } from "Redux/store";
import { fetchTask, updateTask, createTask, deleteTask } from "Redux/Admin/TaskManager/Tasks/action";

import { settings, initialSettings, initialValues } from './const';
import { ADMIN_PATH } from "utils/routes";

import type { ITask } from 'Redux/Admin/TaskManager/Tasks/type';

const Task = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams<{ id: string }>();
  const isNew = id === 'new';

  const { entities, loading, error } = useSelector((state: RootState) => state.fetchTasks);

  const [modal, contextHolder] = Modal.useModal();

  const ReachableContext = createContext<string | null>(null);

  useEffect(() => {
    if (id && !isNew) {
      dispatch(fetchTask(id));
    }
  }, [dispatch, isNew, id]);

  const onFinish = (values: any) => {
    if (isNew) {
      dispatch(createTask(values, handleCreate));
    }
    else if (id) {
      dispatch(updateTask(values, id));
    }
  };

  const handleCreate = (project: ITask) => {
    if (project && project.id) {
      navigate(`${ADMIN_PATH}/task-manager/tasks/${project.id}`);
    }
  }

  if (!id) {
    navigate(`${ADMIN_PATH}/task-manager/tasks`, { replace: true });
    return null;
  }

  const task = isNew ? initialValues : entities[id];

  if (!task) {
    return <Spin />;
  }

  const menuItems: MenuProps['items'] = [
    /* {
      label: 'View Areas',
      key: '1',
    }, */
    {
      label: 'Delete Task',
      key: '2',
      danger: true,
    }
  ];

  const modalConfig = {
    title: 'Delete the task?',
    content: <span>Are you sure you want to delete the task <b>{task.id}</b>?</span>,
    confirmLoading: true
  };

  const handleMenuClick: MenuProps['onClick'] = async (e) => {
    /* if (e.key === '1') {
      navigate(`${ADMIN_PATH}/goals/journeys/user-areas/?masterplan=${id}`);
    }
    else  */if (e.key === '2') {
      const confirmed = await modal.confirm(modalConfig);

      if (confirmed) {
        dispatch(deleteTask(id, () => {
          navigate(`${ADMIN_PATH}/task-manager/tasks`, { replace: true });
        }));
      }
    }
  };

  const menuProps = {
    items: menuItems,
    onClick: handleMenuClick,
  };

  return (
    <ReachableContext.Provider value="Light">
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Row>
          <Col span={12}>
            <Flex
              gap="middle"
              align="center"
              justify="space-between"
              style={{ marginBottom: 16 }}
            >
              <Link to={`${ADMIN_PATH}/task-manager/tasks`}>Back</Link>
            </Flex>

            <Card title={`${isNew ? 'Create' : '' } Task`} extra={
              isNew ? null : <Dropdown menu={menuProps} placement="bottom">
                <Button>
                  <Space>
                    Manage Task
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            }>
              <ObjectForm
                data={task}
                errorData={error}
                isNew={isNew}
                settings={isNew ? initialSettings : settings}
                loading={loading}
                onFinish={onFinish}
              />
            </Card>
          </Col>
        </Row>
      </div>

      {contextHolder}
    </ReachableContext.Provider>
  );
}

export default Task;
